export default [
  'NL',
  'LU',
  'CH',
  'IS',
  'EE',
  'LT',
  'HU',
  'BE',
  'PT',
  'GB',
  'SK',
  'HR',
  'CZ',
  'IT',
  'FI',
  'PL',
  'MT',
  'DE',
  'SI',
  'RO',
  'BG',
  'AT',
  'SE',
  'CY',
  'DK',
  'FR',
  'LI',
  'IE',
  'ES',
  'GR',
  'LV',
  'NO',
];
